export const GOLDEN_RATIO = 0.618;
export const MAX_WIDTH_VIEWPORT_RATIO = 0.8;
export const MIN_WIDTH_REM = 50;
export const CLOSE_ANIMATION_DURATION_MS = 200;
export const KEYBOARD_RESIZE_STEP_REM = 2;
export const REM_BASE = 10;
export const SESSION_STORAGE_KEY = 'AI_CHAT_DRAWER_WIDTH';
export const DEFAULT_TITLE_ID = 'ai-chat-drawer-title';
